<template>
    <v-footer padless class="new-footer">
        <v-container>
            <v-row align="center" no-gutters>
                <v-col class="d-flex align-center footer-left">
                    <span class="footer-copyright">© NEW {{ new Date().getFullYear() }}</span>
                    <v-btn v-for="link in linksunten" :key="link.text" text small class="footer-link">
                        <a :href="link.href" target="_blank"
                            style="text-decoration: none; color: inherit; display: contents;">
                            {{ link.text }}
                        </a>
                    </v-btn>
                </v-col>
                <v-col cols="auto" class="d-flex align-center footer-right">
                    <v-btn v-for="social in linksoben" :key="social.text" icon small class="footer-social-btn">
                        <a :href="social.href" target="_blank"
                            style="text-decoration: none; color: inherit; display: contents;">
                            <v-icon size="20">{{ social.icon }}</v-icon>
                        </a>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
export default {
    name: "AppFooter",
    data() {
        return {
            linksoben: [
                {
                    text: "Facebook",
                    href: "https://www.facebook.com/new.niederrhein",
                    icon: "$facebookIcon"
                },
                {
                    text: "Instagram",
                    href: "https://www.instagram.com/new_gruppe",
                    icon: "$instagramIcon"
                },
                {
                    text: "Youtube",
                    href: "https://www.youtube.com/user/NEWniederrhein",
                    icon: "$youtubeIcon"
                },
            ],
            linksunten: [
                {
                    text: "NEW-Energie",
                    href: "https://www.new-energie.de/gk",
                    icon: null
                },
                {
                    text: "AGB",
                    href: "https://www.new-energie.de/agb",
                    icon: null
                },
                {
                    text: "Impressum",
                    href: "https://www.new-energie.de/impressum",
                    icon: null
                },
                {
                    text: "Datenschutz",
                    href: "https://www.new-energie.de/datenschutzhinweise",
                    icon: null
                },
                {
                    text: "rechtliche Hinweise",
                    href: "https://www.new-energie.de/rechtliche-hinweise",
                    icon: null
                }
            ]
        }
    },
    methods: {},
    computed: {},
    watch: {},
    mounted() { }
}
</script>

<style>
@keyframes footerGradient {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

.new-footer {
    background: linear-gradient(90deg, #281e78, #004ba0, #008cc8, #004ba0, #281e78) !important;
    background-size: 300% 100% !important;
    animation: footerGradient 12s ease infinite;
    color: #ffffff !important;
    padding: 10px 0 !important;
    overflow: visible !important;
}

.new-footer .footer-left {
    flex-wrap: wrap;
    gap: 0;
}

.new-footer .footer-copyright {
    color: #ffffff;
    font-family: 'Geometria', Arial, Helvetica, sans-serif;
    font-weight: 500;
    font-size: 13px;
    margin-right: 8px;
    white-space: nowrap;
}

.new-footer .footer-link {
    color: #ffffff !important;
    font-family: 'Geometria', Arial, Helvetica, sans-serif !important;
    font-weight: 400 !important;
    font-size: 13px !important;
    text-transform: none !important;
    letter-spacing: normal !important;
    min-width: auto !important;
    padding: 0 8px !important;
    height: 28px !important;
}

.new-footer .footer-link:hover,
.new-footer .footer-link:hover a {
    color: #55c3f0 !important;
    text-decoration: none !important;
}

.new-footer .footer-link a {
    color: #ffffff !important;
}

.new-footer .footer-social-btn {
    color: #ffffff !important;
    margin-left: 8px;
    width: 32px !important;
    height: 32px !important;
    overflow: visible !important;
}

.new-footer .footer-social-btn:hover {
    color: #55c3f0 !important;
}
</style>